<template>
  <div class="main_container">
    <article class="main_hero">
      <section class="main_card">

        <a-modal class="modal_container" v-if="showModal" :title="`Release Version: ${selectedRelease.version}`"
          :closable="false" centered :visible="true">
          <template slot="footer">
            <a-button key="submit" type="primary" @click="showModal = false">Close</a-button>
          </template>
          <p>Release Date : <span>{{ selectedRelease.release_date }}</span></p>
          <p> Modules:
            <span class="ant-tag ant-tag-blue" v-for="mod in selectedRelease.modules">{{ mod }}</span>
          </p>
          <p> Status : <span>{{ selectedRelease.status }}</span></p>
          <p> Sprint # : <span>{{ selectedRelease.sprint }}</span></p>
          <p> Changes: </p>
          <ul class="container_ul">
            <li v-for="item in selectedRelease.description">{{ item }}</li>
          </ul>
        </a-modal>

        <!-- <section class="hero_image">
          <h1>New Release</h1>
          <a-tooltip placement="top">
            <template slot="title">
              <span>Show more details</span>
            </template>

            <div class="new_release_card" v-if="tableData.length !== 0" @click="showDetails(tableDataInstance[0].id)">
              <p><span>Version:</span> {{ tableDataInstance.length !== 0 ? tableDataInstance[0].version : "--/--" }}</p>
              <p><span>Release Date:</span> {{ tableDataInstance.length !== 0 ? tableDataInstance[0].release_date :
                "--/--"
              }}</p>
              <p>
                <span>Modules:
                  <span v-if="tableDataInstance.length !== 0" class="ant-tag ant-tag-blue"
                    v-for="mod in tableDataInstance[0].modules">{{
                      mod }}</span>
                </span>
                {{ tableDataInstance.length === 0 ? "--/--" : '' }}
              </p>
              <p> <span>Status:</span> {{ tableDataInstance.length !== 0 ? tableDataInstance[0].status : "--/--" }}</p>
              <p><span>Sprint #:</span> {{ tableDataInstance.length !== 0 ? tableDataInstance[0].sprint : "--/--" }}</p>
              <p><span>Description:</span></p>
              <p>{{ tableDataInstance.length !== 0 ? tableDataInstance[0].description.slice(0, 1)[0].slice(0, 50) :
                "--/--"
              }}...</p>
            </div>
          </a-tooltip>
        </section> -->

        <section class="release_cards">
          <p><h2>Latest Releases</h2></p>
          <div class="card-container">
            <div v-for="item in (tableDataInstance.slice(0, 3))" :key="item.id" @click="showDetails(item.id)">
              <a-tooltip placement="top">
                <template slot="title">
                  <span>Show more details</span>
                </template>
                <p><span>Version:</span> {{ item.version }}</p>
                <p><span>Release Date:</span> {{ item.release_date }}</p>
                <p>
                  <span>Modules:
                    <span class="ant-tag ant-tag-blue" v-for="mod in item.modules">{{ mod }}</span>
                  </span>
                </p>
                <p><span>Status:</span> {{ item.status }}</p>
                <p><span>Sprint #:</span> {{ item.sprint }}</p>
                <p><span>Description:</span></p>
                <p v-for="desc in (item.description.slice(0, 1))">{{ desc.slice(0, 50) }} <span>...</span></p>
              </a-tooltip>
            </div>
          </div>
        </section>

        <section class="drawer_button">
          <span> Older Releases </span>
          <!-- <i class="fa fa-angle-double-right" aria-hidden="true"></i> -->
        </section>

        <section class="older_releases_drawer">
          <a-table :columns="columns" :data-source="tableData" :pagination="pagination" @change="handleTableChange"
            :loading="loading" :rowKey="(record) => record.id" class="ant-table-striped ant-table" bordered size="small">
            <center slot="action" slot-scope="record">
              <a-button type="primary" @click="showDetails(record)"> View Details </a-button>
            </center>
          </a-table>
        </section>

      </section>
    </article>
  </div>
</template>
<script>
// import secureStorage from '../controllers/secureStorage';
import HTTPRequest from '../controllers/httpRequest'
import { mapState } from 'vuex'
import axios from 'axios';


export default {
  mounted: async function () {
    await this.handleTableChange(this.pagination)
    const { data } = await HTTPRequest.getRequest(`${this.endPoint}releases`)
    this.tableDataInstance = data.map((item) => {
      item.release_date = new Date(item.release_date).toLocaleDateString()
      item.modules = JSON.parse(item.modules)
      item.description = JSON.parse(item.description)
      return item
    })
    // this.tableData = this.tableDataInstance.slice(4)
  },

  methods: {
    async showDetails(id) {
      this.showModal = true
      let data = await HTTPRequest.getRequest(`${this.endPoint}releases/${id}`)
      let release_date = new Date(data.release_date).toLocaleDateString()
      let modules = JSON.parse(data.modules)
      let description = JSON.parse(data.description)
      this.selectedRelease = { ...data, release_date, modules, description }

    },
    async handleTableChange(pagination) {
      this.loading = true
      var pager = { ...this.pagination };
      this.currentPage = pagination.current
      pager.current = pagination.current;
      pager.pageSize = Number(this.default_display);
      this.pagination = pager;
      await HTTPRequest.getRequest(`${this.endPoint}releases?per_page=${this.default_display}&page=${pagination.current}`)
        .then((resp) => {
          var pagination = { ...this.pagination };
          pagination.total = resp.total;
          pagination.pageSize = Number(this.default_display);
          this.pagination = pagination
          let data = resp.data.map((item) => {
            item.release_date = new Date(item.release_date).toLocaleDateString()
            return item
          })
          this.tableData = this.currentPage === 1 ? data.slice(3) : data
        })
      this.loading = false;
    },
  },
  computed: {
    ...mapState(['endPoint', 'profileId', "parameters"]),
  },
  data: function () {
    return {
      tableData: [],
      tableDataInstance: [],
      columns: [
        {
          title: 'Version',
          dataIndex: 'version'
        },
        {
          title: 'Status',
          dataIndex: 'status'
        },
        {
          title: 'Release Date',
          dataIndex: 'release_date'
        },
        {
          title: 'Sprint #',
          dataIndex: 'sprint'
        },
        {
          title: 'Release Notes',
          dataIndex: 'id',
          key: 'x',
          scopedSlots: { customRender: 'action' }
        },
      ],
      spinning: false,
      default_display: 10,
      currentPage: 1,
      pagination: {
        current: 1,
        pageSize: 10,
      },
      loading: false,
      showModal: false,
      selectedRelease: {}
    }
  }
}
</script>
<style scoped>
/* Main classes layout */
* {
  font-size: 12px;
}

.modal_container p,  .modal_container span {
  font-size: 12px;
}
.modal_container p {
  font-weight: bold;
}
.modal_container p span {
  font-weight: normal;
}
.modal_container .container_ul{
  margin-top: 10px;
  border-radius: 5px;
  border: 2px solid rgb(0, 37, 67, 0.5);
  padding: 20px;
  height: 300px;
  overflow: hidden;
  overflow-y: scroll;
}
.modal_container .container_ul li {
  margin-left: 10px;
}

.main_container {
  display: flex;
  flex-direction: column;
}

.main_hero {
  background-color: #ECEEF2;
  padding: 30px;
}

.main_hero p {
  margin: 5px 0;
}

.main_hero span {
  font-weight: bold;
}

.main_card {
  background-color: white;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 20px
}

.main_card section {
  margin: 10px 0;
}

/* END*/

/* Hero Image and New Release Layout */
.hero_image {
  background-image: url('../assets/background/RELEASES/releases_background_image.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  column-gap: 20px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-areas:
    "col1 col2 col3";
  padding: 120px 0;
}

h2{
  font-size: 1.5rem;
}

.new_release_card {
  grid-area: col3;
  box-shadow: 9px 10px 13px -5px rgba(0, 0, 0, 0.55);
  -webkit-box-shadow: 9px 10px 13px -5px rgba(0, 0, 0, 0.55);
  -moz-box-shadow: 9px 10px 13px -5px rgba(0, 0, 0, 0.55);
}

/* END */

/* Combined layout for card container and new release card on top */
.card-container {
  align-items: center;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;

}

.card-container p {
  margin: 5px 0
}

.card-container div:nth-child(2) {
  margin: 0 20px;
}

.new_release_card,
.card-container div {
  background-color: rgb(255, 255, 255);
  border-radius: 5px;
  border: 2px solid rgb(0, 37, 67, 0.5);
  padding: 10px;
  transition: all .2s;
}

/* END */

/* Drawer Button and Old release drawer layout */
.older_releases_drawer {
  border-radius: 5px;
}

.drawer_button {
  background-color: #C3D5DF;
  border-radius: 5px;
  padding: 10px;
  text-align: center;
  transition: all .2s;
}

/* END */

/* Hover Effects */
.drawer_button:hover {
  box-sizing: border-box;
  cursor: pointer;
  color: white;
  background-color: #8EA2B0;
}

.card-container div:hover,
.new_release_card:hover {
  transform: scale(1.01);
  cursor: pointer;
  box-shadow: 9px 10px 13px -5px rgba(0, 0, 0, 0.55);
  -webkit-box-shadow: 9px 10px 13px -5px rgba(0, 0, 0, 0.55);
  -moz-box-shadow: 9px 10px 13px -5px rgba(0, 0, 0, 0.55);

  /* END */
}
</style>
